import React, { Component } from "react";
import { TextInput, DialogBox, DialogBoxFooterType, NoLink, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { InjectedIntlProps } from "@ai360/core/intl";
import { messages } from "../../i18n-messages";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
import { IBackOfficeListProps, IListState } from "../interfaces";

class BackOfficeList extends Component<IBackOfficeListProps & InjectedIntlProps, IListState> {
    static PROPS_BACKOFFICE_CODE = "backOfficeProductCode";

    constructor(props) {
        super(props);
        this.state = {
            editingItem: false,
        };
    }

    onEdit = (record, index) => {
        const keysToUpdate = [BackOfficeList.PROPS_BACKOFFICE_CODE];
        this.setState({ editingItem: true });
        this.props.onEdit({ record, index, keysToUpdate });
    };
    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, onChange, toggleModal } =
            this.props;
        const formData = { ...editData };
        return (
            <DialogBox
                hideCloseX
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.backOfficeCode
                )}
                actionDisabled={!editData[BackOfficeList.PROPS_BACKOFFICE_CODE]}
                onClose={() => toggleModal("isEditing", false)}
                onAction={() => onAddOrEditItem()}
                isOpen={isEditing}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                action="save"
                testId="back-office-list-add-edit-modal"
            >
                <div className="dialog-box-body">
                    <TextInput
                        tabIndex={0}
                        maxLength={50}
                        required
                        autoFocus
                        placeholderText={formatMessage(messages.backOfficeCode)}
                        value={formData[BackOfficeList.PROPS_BACKOFFICE_CODE] || ""}
                        onChange={(value) =>
                            onChange({
                                [BackOfficeList.PROPS_BACKOFFICE_CODE]: value,
                            })
                        }
                        testId="back-office-list-code-input"
                    />
                </div>
            </DialogBox>
        );
    };

    render() {
        const { record, formatMessage, renderDeleteModal } = this.props;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {record && record.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={record}
                        columns={{
                            [BackOfficeList.PROPS_BACKOFFICE_CODE]: {
                                title: formatMessage(messages.backOfficeCode),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        className="add-link"
                        label={createAddLinkLabelText(formatMessage, messages.backOfficeCode)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(BackOfficeList);
